import { Accordion, AccordionItem, AccordionItemBody, AccordionItemHeader, CheckboxField } from '@wk/components-react16';

const FacetsFilter = ({ data }: any) => {
    const { promptPayload, setPromptPayload, getPrompts, facets, setFecets, pagination } = data;
    const handleSelection = (node: any, code: string, status: boolean = false) => {
        node.checked = status;
        const updatedFacetsTree = facets.map((item: any) => {
            if (item?.code == 'catIds' && item?.children?.length > 0) {
                if (code == 'catIds'){
                    const children = item?.children.map((itm: any) => {
                        if (itm.code?.toUpperCase() !== node.type?.toUpperCase()) return itm;

                        return {
                            ...itm,
                            children: itm?.children.map((child: any) =>
                                child.id === node.id ? { ...child, checked: status } : child
                            )
                        };
                    });

                    return { ...item, children };
                }
            } else {
                return {
                    ...item,
                    children: code === item.code ? item?.children.map((child: any) => {
                        if (child?.name?.toUpperCase() === node.name?.toUpperCase()) {
                            return { ...child, checked: status };
                        }
                        return child;
                    }) : item?.children,
                }
            }
        });
        setFecets([...updatedFacetsTree]);
        handleFilter();
    };

    const handleFilter = () => {
        facets.forEach((item: any) => {
            if (item?.code == 'promptTypeId') {
                promptPayload.promptType = item?.children.filter((item: any) => item.checked)
                    .map((item: any) => item.id);
            }
            if (item?.code == 'createdBy') {
                promptPayload.createdBy = item?.children.filter((item: any) => item.checked)
                    .map((item: any) => item.name);
            }
            if (item?.code == 'updatedBy') {
                promptPayload.updatedBy = item?.children.filter((item: any) => item.checked)
                    .map((item: any) => item.name);
            }
            if (item?.code == 'catIds' && item.children.length > 0) {
                promptPayload.catIds =  item?.children.map((itm: any) => {
                    return itm.children.filter((i: any) => i.checked)
                        .map((it: any) => it.id);
                }).flat();
            }
        })
        setPromptPayload({ ...promptPayload })
        getPrompts(1, pagination.pageSize);
    }

    return (
        <div className="suggestion-list" style={{ position: 'relative', maxHeight: 'calc(100vh - 226px)', zIndex: 0 }}>
            {facets?.length > 0 ? facets?.map((item: any, index: number) => (
                <div key={index} className='custom-accordion custom-accordion-scroll-hide'>
                    <Accordion>
                        <AccordionItem isOpen isScrollbarEnabled={false}>
                            <h2 id="generalSettings" slot="accordionItemHeader">
                                <AccordionItemHeader>{item?.name}</AccordionItemHeader>
                            </h2>
                            {item?.children?.length > 0 ? (
                                <AccordionItemBody slot="accordionItemBody">
                                    <RenderTreeChild items={item.children} code={item.code} handleSelection={handleSelection} />
                                </AccordionItemBody>
                            ): null}
                        </AccordionItem>
                    </Accordion>
                </div>
            )) : null}
        </div>
    );
};


export const RenderTreeChild = ({ items, code, handleSelection }: any) => {
    return (items && items.length > 0 && <ul className='mb-0'>{items.map((item: any, i: number) => {
        if (item?.children?.length > 0) {
            return (
                <li key={i} className='small-font'>
                    <div className="pl-10 bg-light item pe-none">{item.name}</div>
                    <RenderTreeChild items={item.children} code={code} handleSelection={handleSelection} />
                </li>
            );
        } else {
            return (
                <li key={i} className='small-font' style={{ padding: '2px 0' }}>
                    <div className='item'>
                        {item?.parentNames?.length > 0 && <div className="breadcrumbs">{item?.parentNames?.join(' > ')}</div>}
                        <div className='flex'>
                            <div className='custom-fs-field'>
                                <CheckboxField label={item.name}>
                                    <input
                                        name="tag"
                                        type="checkbox"
                                        checked={item.checked || false}
                                        onChange={(event: any) => handleSelection(item, code, event.target.checked)}
                                    />
                                </CheckboxField>
                            </div>
                            <div className='ms-auto'>({item.count})</div>
                        </div>
                    </div>
                </li>
            );
        }
    })}
    </ul>)
};

export default FacetsFilter;